var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64 13.318a9.929 9.929 0 0 1 6.733-2.305c2.167.077 4.31.855 6.071 2.308a1 1 0 0 0 1.273-1.543 12.095 12.095 0 0 0-7.272-2.763 11.923 11.923 0 0 0-8.084 2.767 1 1 0 1 0 1.28 1.536zM2.081 9.75a14.906 14.906 0 0 1 10.236-3.737 15.093 15.093 0 0 1 9.604 3.739 1 1 0 1 0 1.317-1.505 17.09 17.09 0 0 0-10.876-4.234A16.904 16.904 0 0 0 .759 8.25a1 1 0 1 0 1.322 1.5zm7.028 7.175a4.95 4.95 0 0 1 3.274-.906c.891.07 1.765.378 2.523.909a1 1 0 0 0 1.148-1.638 7.093 7.093 0 0 0-3.513-1.265 6.954 6.954 0 0 0-4.59 1.269 1 1 0 1 0 1.158 1.63zM12 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.3d3c6cf4a9cac6ee43e3a843cb693f90.svg";
export { ForwardRef as ReactComponent };